import { useAuth } from '@/zustand/auth-store';
import { ROUTES } from './routes';
import ApiInstance from '@/middlewares/api-interceptor';

const login = async payload => {
  const { data } = await ApiInstance.post(ROUTES.LOGIN, payload, {
    skipRefresh: true,
    skipRedirect: true,
    skipAuthHeader: true,
  });
  return data;
};

const verifyLoginOtp = async payload => {
  const { data } = await ApiInstance.post(ROUTES.VERIFY_LOGIN_OTP, payload, {
    skipAuthHeader: true,
  });
  return data;
};

const resendLoginOtp = async payload => {
  const { data } = await ApiInstance.post(ROUTES.RESEND_LOGIN_OTP, payload, {
    skipAuthHeader: true,
  });
  return data;
};

const refreshAccessToken = async () => {
  const { refreshToken } = useAuth.getState();
  const { data } = await ApiInstance.post(
    ROUTES.REFRESH_TOKEN,
    { refresh: refreshToken },
    { skipRefresh: true, skipAuthHeader: true }
  );
  return data?.token || data;
};

const logout = async () => {
  const refreshToken = useAuth.getState().refreshToken;

  if (!refreshToken) {
    throw new Error('No refresh token found');
  }

  const { data } = await ApiInstance.post(ROUTES.LOGOUT, {
    refreshToken,
  });
  return data;
};

const dashboardLogin = async body => {
  const { data } = await ApiInstance.post(ROUTES.DASHBOARD_LOGIN, body);
  return data;
};
const dashboardVerifyOtp = async body => {
  const { data } = await ApiInstance.post(ROUTES.DASHBOARD_VERIFY_OTP, body);
  return data;
};
const dashboardResendOtp = async body => {
  const { data } = await ApiInstance.post(ROUTES.DASHBOARD_RESEND_OTP, body);
  return data;
};

const dashboardRefreshAccessToken = async () => {
  const { refreshToken } = useAuth.getState();
  const { data } = await ApiInstance.post(
    ROUTES.DASHBOARD_REFRESH_TOKEN,
    { refreshToken },
    { skipRefresh: true, skipAuthHeader: true }
  );
  return data?.token || data;
};

/**
 * Exchange magic-link token (from URL ?token=...) for access token + user.
 * GET /auth/magic-link/:token
 * Response: { message, token: { accessToken, refreshToken }, data: user }
 */
const getMagicLink = async token => {
  const { data } = await ApiInstance.get(`${ROUTES.MAGIC_LINK}/${encodeURIComponent(token)}`);
  return data;
};
const otpRequest = async body => {
  const { data } = await ApiInstance.post(ROUTES.REQUEST_OTP, body);
  return data;
};
export const AuthApis = {
  login,
  verifyLoginOtp,
  resendLoginOtp,
  logout,
  refreshAccessToken,
  dashboardRefreshAccessToken,
  dashboardResendOtp,
  dashboardVerifyOtp,
  dashboardLogin,
  getMagicLink,
  otpRequest,
};
